function generatePath(locationPrefix, location, fileName, extension, locationSuffix = "") {
    let directory;
    if (!locationPrefix) {
        directory = location;
    } else {
        directory = `${locationPrefix}/${location}`;
    }
    if (fileName !== "") {
        return `${directory}/${fileName}${locationSuffix}.${extension}`;
    } else {
        return `${directory}${locationSuffix}.${extension}`;
    }
}
export default generatePath;